// extracted by mini-css-extract-plugin
module.exports = {"notFoundContainer":"SearchNotFound_notFoundContainer__2gSqe","footer":"SearchNotFound_footer__2OrAc"};